import { MessageTypes } from '@amzn/dvui/dist/Block'
import { DetailPageActionTypes } from './constants'
import { DVStringAttrs } from '../utils/stringUtils'
import { StringId } from '../components/localizer/localizer'

type BannerPayload = {
  stringId?: StringId
  string?: string
  heading?: string
  dvStringAttrs?: DVStringAttrs
  type: MessageTypes
}
export interface ICreateBanner {
  type: typeof DetailPageActionTypes.CreateBanner
  payload: BannerPayload
}

export interface IClearBanner {
  type: typeof DetailPageActionTypes.ClearBanner
}

export const createBanner = (payload: BannerPayload): ICreateBanner => ({
  type: DetailPageActionTypes.CreateBanner,
  payload
})

export const clearBanner = () => ({
  type: DetailPageActionTypes.ClearBanner
})
